import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import Form from "containers/transport/Form";
import { addNewTransport } from "store/actions";

export class AddNewTransport extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleSubmit = item => {
    const { history } = this.props;
    const payload = {
      history,
      data: item,
    };
    this.props.addNewTransport(payload);
  };

  handleCancel = () => {
    const { history } = this.props;
    history.push("/transport");
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Add New Transport | JLS Express</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
              title="Home"
              backLink={"/transport"}
              breadcrumbItem="Add New Transport"
            />
            <Form onSubmit={this.handleSubmit} />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddNewTransport.propTypes = {
  history: PropTypes.object,
  addNewTransport: PropTypes.func,
};

const mapStateToProps = ({ transport }) => {
  return transport;
};

export default withRouter(
  connect(mapStateToProps, {
    addNewTransport,
  })(AddNewTransport)
);
